import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlurCircularIcon(props: IconProps) {
    return <Icon {...props} iconKey={"blur_circular"}/>
}
